import client from './client'

export default {
  create ({ email, password }) {
    const body = {
      email,
      password
    }

    return client.post('/api/sessions.json', { json: body }).json()
  }
}
